import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, interval, Observable, of, Subscription, timer } from 'rxjs';
import { delay, map, take } from 'rxjs/operators';
import { CameraTestModalComponent } from 'src/app/events/live/camera-test/camera-test-modal.component';
import { TimeSpan } from 'src/app/events/live/live-event-dashboard/live-event-dashboard.component';
import { EventDashboardViewModel, LiveEventViewModel, PagedActiveUserViewModel, StreamHealthViewModel } from 'src/app/_models/generatedModels';
import { SelectedDevice } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LiveEventService } from 'src/app/_services/generatedServices';
import { OpentokService } from 'src/app/_services/opentok.service';
const initLayoutContainer = require('opentok-layout-js');
import { Flowplayer, FPEvent } from "@flowplayer/player";
import Player = Flowplayer.Player;
declare var flowplayer: any;

@Component({
  selector: 'bxl-multi-view-video',
  templateUrl: 'multi-view-video.component.html',
})
export class MultiViewVideoComponent implements OnInit, OnDestroy {
  initialized = false;
  session: OT.Session;
  soundMuted: boolean = true;
  public selectedDevice: SelectedDevice;
  publisher: OT.Publisher;
  public publishingAudio = true;
  public publishingVideo = true;
  public showPeople = false;
  private azureStreamChecker: Subscription;
  public showTools = false;
  livePlaying = false;
  livePlayer: Player;
  @ViewChild('livePLayer') livePLayerRef: ElementRef;

  public showQuestions = false;
  userCount: number;
  public publishing = false;
  timer$: Observable<TimeSpan>;
  audioHealthData: StreamHealthViewModel[] = [];
  videoHealthData: StreamHealthViewModel[] = [];
  dashboard: EventDashboardViewModel;
  @Input() event: LiveEventViewModel;
  obsArray: BehaviorSubject<StreamHealthViewModel[]> = new BehaviorSubject<StreamHealthViewModel[]>([]);
  array$: Observable<any> = this.obsArray.asObservable();
  @Input() connection: HubConnection;
  openTokInitialized: boolean;
  public layout: any;
  public streamCount = 0;
  @ViewChild('webRTCLayoutContainer') webRTCLayoutContainer: ElementRef;
  previewing: boolean;
  constructor(private auth: AuthenticationService, private ref: ChangeDetectorRef, private liveEventService: LiveEventService, private modalService: NgbModal, private renderer: Renderer2, private opentokService: OpentokService) {}

  ngOnInit(): void {
    this.InitSignalR();

    if (this.event.isWebRTC) {
      this.InitOpenTok();
    } else {
      this.initAzure();
    }

    if (this.event.streamingStarted) {
      this.timer$ = this.getElapsedTime();
    }
    this.initialized = true;
  }

  initAzure() {
    this.liveEventService.getDashboardIgnoreCache(this.event.id).subscribe((result) => {
      this.dashboard = result;
      this.azureStreamChecker = interval(3000).subscribe((val) => this.getDashboardData());
    });
  }

  getDashboardData() {
    if (this.dashboard.isChannelRunning && this.dashboard.isIngesting && this.dashboard.isBroadcastRunning && this.dashboard.streamingUrl && this.dashboard.streamingUrl.length > 0) {
      this.setupAzureLive();
      return;
    }

    this.liveEventService.getDashboardIgnoreCache(this.event.id).subscribe((dashboard) => {
      this.dashboard = dashboard;
      this.setupAzureLive();
    });
  }

  setupAzureLive() {
    if (this.livePlayer && this.dashboard.isBroadcastRunning && this.dashboard.streamingUrl && (!this.livePlaying || this.livePlayer.currentTime < 2)) {
      this.livePlayer.setSrc(this.dashboard.streamingUrl);
      this.previewing = false;
      this.livePlayer.togglePlay(true);
      this.livePlaying = true;
      console.log('Player already exists. playing stream');
    }

    if (this.livePlayer) {
      console.log('Player already exists. not playing stream');
      return;
    }

    if (!this.dashboard.isChannelRunning || !this.dashboard.isIngesting) {
      return;
    }



    if (!this.dashboard.isBroadcastRunning && !this.dashboard.streamingUrl) {
      console.log('Preview Stream');
      this.livePlayer = flowplayer('#livePLayer' + this.event.id, {
        qsel: {
          labels: [],
        },

        src: this.dashboard.previewUrl,
        autoplay: flowplayer.autoplay.AUDIO_REQUIRED,
        ui: flowplayer.ui.NO_FULLSCREEN,
        token: "eyJraWQiOiIwWE44RnRTYkQxblYiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6MzgsXCJpZFwiOlwiMFhOOEZ0U2JEMW5WXCJ9IiwiaXNzIjoiRmxvd3BsYXllciJ9.wHlyQZ86rIHD8ldgnpiWbmFBmR4zt_3FSj78GMk7lfQ1es7K8y0MuHzbqcJfp0lm6LcUbUkQ5PsazIsAybxivg"
      });
      console.log(this.livePlayer);
      this.livePlayer.on('error', this.playbackErrorOccured.bind(this));
      this.previewing = true;
      return;
    } else if (this.dashboard.isBroadcastRunning && this.dashboard.streamingUrl) {
      console.log('Broadcast Stream');
      this.livePlayer = flowplayer('#livePLayer' + this.event.id, {
        qsel: {
          labels: [],
        },
        dvr: true,
        live: true,
        seekable: true,
        controls: true,
        src: this.dashboard.streamingUrl,
        autoplay: flowplayer.autoplay.AUDIO_REQUIRED,
        ui: flowplayer.ui.NO_FULLSCREEN,
        token: "eyJraWQiOiIwWE44RnRTYkQxblYiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6MzgsXCJpZFwiOlwiMFhOOEZ0U2JEMW5WXCJ9IiwiaXNzIjoiRmxvd3BsYXllciJ9.wHlyQZ86rIHD8ldgnpiWbmFBmR4zt_3FSj78GMk7lfQ1es7K8y0MuHzbqcJfp0lm6LcUbUkQ5PsazIsAybxivg"
      });
      this.livePlayer.on('error', this.playbackErrorOccured.bind(this));
      this.previewing = false;
      this.livePlaying = true;
    }
  }

  playbackErrorOccured(err: FPEvent<unknown>) {
    console.info("error occured");
    console.info(err);
    this.livePlaying = false;
    this.previewing = false;
  }

  InitSignalR(): any {
    this.connection.on('streamStartedv2', (eventId: number, startTime, dashboard: EventDashboardViewModel) => {
      if (eventId === this.event.id) {
        console.log('stream started');
        this.event.streamingStarted = true;
        console.log(startTime);
        this.event.streamingStartedTime = startTime;

        this.ref.detectChanges();
        of(null)
          .pipe(delay(500))
          .subscribe((result) => {
            console.log('resizing');
            this.layout();
          });

        this.timer$ = this.getElapsedTime();
      }
    });

    this.connection.on('azureMediaEvent', (data: StreamHealthViewModel) => {
      if (data.channel == this.event.streamingChannel && data.trackType == 'video') {
        this.videoHealthData.push(data);
        this.addElementToObservableArray(data);
        console.log(data);
      }

      if (data.channel == this.event.streamingChannel && data.trackType == 'audio') {
        this.audioHealthData.push(data);
        console.log(data);
      }
    });
    this.connection.on('streamFinished', (eventId: number) => {
      if (eventId === this.event.id) {
        console.log('stream ended');
        this.event.streamingStarted = false;
        this.event.streamingFinished = true;

        this.session.disconnect();
        this.publishing = false;
        this.streamCount = 0;
        this.ref.detectChanges();
        of(null)
          .pipe(delay(500))
          .subscribe((result) => {
            this.layout();
          });
      }
    });
    this.initialized = true;
  }

  addElementToObservableArray(item) {
    this.array$.pipe(take(1)).subscribe((val) => {
      const newArr = [...val, item];
      this.obsArray.next(newArr);
    });
  }

  usersUpdated(event: PagedActiveUserViewModel) {
    this.userCount = event.totalCount;
  }

  get offAirImage() {
    if (this.event.sponsorOffAirImage) {
      return 'fetchimage?filename=' + this.event.sponsorOffAirImage;
    } else {
      return '../../assets/off-air.png';
    }
  }

  InitOpenTok() {
    this.ref.detectChanges();
    this.layout = initLayoutContainer(this.webRTCLayoutContainer.nativeElement).layout;
    let layout = this.layout;

    if (this.openTokInitialized) {
      return;
    }

    console.log('initializing opentok');

    this.opentokService
      .initSessionForEvents(this.event.id)
      .then((session: OT.Session) => {
        this.session = session;

        this.session.on('streamPropertyChanged', (event) => {
          console.log('changed');
          console.log(event.stream.streamId);
        });

        this.session.on('streamCreated', (event) => {
          console.log(event.stream.name);
          console.log(event.stream.connection.data);
          this.streamCount++;

          let subscription = this.session.subscribe(event.stream, 'webRTCLayoutContainer' + this.event.id, {
            insertMode: 'append',
            style: { nameDisplayMode: 'off' },
          });

          if (subscription.stream.videoType === 'screen') {
            subscription.element.classList.add('OT_big');
          }

          if (subscription.stream.name === 'video') {
            subscription.element.classList.add('OT_ignore');
          }

          subscription.element.addEventListener('dblclick', function () {
            if (subscription.element.classList.contains('OT_big')) {
              subscription.element.classList.remove('OT_big');
            } else {
              subscription.element.classList.add('OT_big');
            }
            layout();
          });

          layout();
          this.ref.detectChanges();
          layout();
          of(null)
            .pipe(delay(5000))
            .subscribe((result) => {
              this.checkMuted();
            });
          this.openTokInitialized = true;
        });
        this.session.on('streamDestroyed', (event) => {
          this.streamCount--;
          session.getSubscribersForStream(event.stream).forEach((subscriber) => {
            subscriber.element.classList.remove('ot-layout');

            setTimeout(() => {
              layout();
            }, 200);
          });
          layout();
          this.ref.detectChanges();
          layout();
        });
      })
      .then(() => this.opentokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }

  showDeviceSettings() {
    const modalRef = this.modalService.open(CameraTestModalComponent, { size: 'lg', backdrop: 'static', ariaLabelledBy: 'modal-basic-title' });
    if (this.selectedDevice) {
      console.log(this.selectedDevice);
      modalRef.componentInstance.selectedDevice = this.selectedDevice;
    }
    modalRef.result.then(
      (result) => {
        this.selectedDevice = result;

        if (this.publisher) {
          this.publisher.destroy();
          if (this.publishing) {
            this.activateCamera();
          }
        }
      },
      (reason) => {}
    );
    return;
  }

  toggleVideo() {
    this.publishingVideo = !this.publishingVideo;
    this.publisher.publishVideo(this.publishingVideo);
  }

  toggleAudio() {
    this.publishingAudio = !this.publishingAudio;
    this.publisher.publishAudio(this.publishingAudio);
  }

  checkMuted() {
    console.log('check muted');
    let selectors = '#webRTCLayoutContainer' + this.event.id + ' div.OT_subscriber video';
    console.log(selectors);
    document.querySelectorAll(selectors).forEach((elem: HTMLVideoElement) => {
      elem.muted = this.soundMuted;
    });
  }

  muteAudio() {
    this.soundMuted = true;
    this.checkMuted();
  }

  unMuteAudio() {
    this.soundMuted = false;
    this.checkMuted();
  }

  unpublish() {
    this.session.unpublish(this.publisher);
    this.publishing = false;
    this.layout();
  }

  activateCamera() {
    this.ref.detectChanges();

    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');

    this.publishingVideo = false;

    if (this.selectedDevice) {
      this.publisher = OT.initPublisher(el, { publishAudio: this.publishingAudio, publishVideo: this.publishingVideo, resolution: '1280x720', name: 'billbob', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' }, audioSource: this.selectedDevice.audioDeviceId, videoSource: this.selectedDevice.videoDeviceId });
    } else {
      this.publisher = OT.initPublisher(el, { publishAudio: this.publishingAudio, publishVideo: this.publishingVideo, resolution: '1280x720', name: 'billbob', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' } });
    }

    let layout = this.layout;

    el.addEventListener('dblclick', function () {
      if (el.classList.contains('OT_big')) {
        el.classList.remove('OT_big');
      } else {
        el.classList.add('OT_big');
      }
      layout();
    });

    this.renderer.appendChild(this.webRTCLayoutContainer.nativeElement, el);
    layout();

    if (this.session) {
      if (this.session['isConnected']()) {
        this.publish();
      }
      this.session.on('sessionConnected', () => this.publish());
    }
  }

  publish() {
    this.session.publish(this.publisher, (err) => {
      if (err) {
        alert(err.message);
      } else {
        this.publishing = true;
      }
    });
  }

  private getElapsedTime(): Observable<TimeSpan> {
    return timer(0, 1000).pipe(
      map(() => {
        let date = new Date(this.event.streamingStartedTime);
        let totalSeconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

        let pre = false;
        if (totalSeconds < 0) {
          pre = true;
        }

        totalSeconds = Math.abs(totalSeconds);

        let hours = 0;
        let minutes = 0;
        let seconds = 0;

        if (totalSeconds >= 3600) {
          hours = Math.floor(totalSeconds / 3600);
          totalSeconds -= 3600 * hours;
        }

        if (totalSeconds >= 60) {
          minutes = Math.floor(totalSeconds / 60);
          totalSeconds -= 60 * minutes;
        }

        seconds = totalSeconds;

        //console.log(hours + ':' + minutes + ':' + seconds);
        return {
          hours: hours,
          minutes: minutes,
          seconds: seconds,
          pre: pre,
        };
      })
    );
  }

  ngOnDestroy(): void {
    if (this.publisher) {
      this.publisher.destroy();
    }

    if (this.azureStreamChecker) {
      this.azureStreamChecker.unsubscribe();
    }

    if (this.livePlayer) {
      console.log('disposed media player');
      this.livePlayer.destroy();
    }

    if (this.session) {
      this.session.off('streamCreated');
      this.session.off('streamDestroyed');
      this.session.disconnect();
    }
  }
}
